
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Find the root element
const root = document.getElementById('root');

// Make sure we have a valid DOM element before rendering
if (root) {
  // Create and render the app
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}
